import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  Badge,
  useTheme as useMuiTheme,
  useMediaQuery,
  Tooltip,
  Switch,
  FormControlLabel,
  Button,
  Popover
} from '@mui/material';
import {
  Menu as MenuIcon,
  AccountCircle,
  Logout,
  Settings,
  Notifications,
  Restaurant,
  DarkMode,
  LightMode,
  Brightness4,
  Home,AdminPanelSettings
} from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { useNotification } from '../../contexts/NotificationContext';
import { useCustomTheme } from '../../contexts/ThemeContext';
import { useRestaurant } from '../../contexts/RestaurantContext';
import { get_notifications_bell_icon, update_notifications, get_notifications_count ,clear_fcm_token} from '../../services/notificationService'



const Header = ({ onSidebarToggle, rootNotificationCount, deliveryNotificationCount, takeawayNotificationCount }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [notifications, setNotifications] = useState([])
  const [notificationClick, setNotificationClick] = useState(false);
  const { user, logout } = useAuth();
  const { showSuccess } = useNotification();
  const { isDarkMode, toggleTheme } = useCustomTheme();
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));
  const navigate = useNavigate();
  const { notificationCount, setNotificationCount } = useRestaurant()
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
  // console.log("Root Notification Count => ", rootNotificationCount)

  async function fetchNotifications() {
    try {
      const response = await get_notifications_bell_icon()
      setNotifications(response.result)
      console.log("Response => ", response)
    }
    catch (error) {
      console.error("Error While Getting Notification for Bell Icon ", error)
    }
  }

  useEffect(() => {
    fetchNotifications()
  }, [])

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleMenuClose();
    await clear_fcm_token()
    await logout();
    localStorage.removeItem('tk_id');
    localStorage.removeItem('user_id');
    showSuccess('Logged out successfully');
  };

  const handleHomePageNavigation = async() => {
    // Show confirmation dialog for public page navigation
    const confirmed = window.confirm(
      'You are about to navigate to the public website. This will log you out of the admin panel. Continue?'
    );

    if (!confirmed) {
      return; // User cancelled
    }

    // Clear authentication tokens when going to public pages
    // console.log("Access Token Refresh => ")
    localStorage.setItem("Header ", "YES");
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    await clear_fcm_token()
    localStorage.removeItem('tk_id');

    // Show success message
    showSuccess('Successfully logged out and navigating to public website');

    // Navigate to home page
    navigate('/');
  };

  // useEffect(()=>{
  //   // setRootNotificationCount(notificationCount)
  // },[rootNotificationCount,notificationCount])

  const handleClick = (event) => {
    setNotificationAnchorEl(event.currentTarget);
    fetchNotifications()
  };

  const handleClose = () => {
    setNotificationAnchorEl(null);
  };

  const handleNotificationRead = async (id, order_type, outlet_id) => {
    try {
      const response = await update_notifications(id);
      const notification_count = await get_notifications_count();
      // console.log(response);
      setNotificationClick(!notificationClick);
      setNotificationCount(notification_count.unread || 0);

      // console.log("order_type Clicking => ", order_type);
      // console.log("outlet_type Clicking => ", outlet_id);
      if (order_type === "CATERING") {
        navigate('/admin/catering')
      }
     else if(order_type === "RESERVATION"){
        navigate('/admin/tables')
      }
      else {
        navigate('/admin/delivery', {
          state: {
            notification_type_clicked: order_type,
            outlet: outlet_id
          }
        });
      }

    } catch (error) {
      console.error(error.message);
    }
  };

  const open = Boolean(notificationAnchorEl);


  const handleNotificationClick = (item) => {
    // Handle click - update read status, navigate, etc.
    console.log('Clicked:', item);
    // Update is_read status in your backend/state
  };

  const handleSeeAll = () => {
    // console.log('See all clicked');
    navigate('/admin/notifications')
    handleClose();
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        borderRadius: 0,
        // height:'77px',
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        color: 'text.primary',
      }}
    >
      <Toolbar sx={{ px: { xs: 1, sm: 2, md: 3 }, minHeight: { xs: '56px', sm: '64px' } }}>
        <IconButton

          edge="start"
          onClick={onSidebarToggle}
          sx={{ mr: 2, color: 'text.primary', zIndex: 1 }}
        >
          <MenuIcon sx={{ fontSize: '1.4rem' }} />
        </IconButton>

        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <AdminPanelSettings sx={{ mr: { xs: 0.5, sm: 1 }, color: 'primary.main', fontSize: { xs: '1.2rem', sm: '1.4rem', md: '2rem' } }} />
          <Typography
            variant="h6"
            fontWeight="600"
            color="primary.main"
            sx={{
              fontSize: { xs: '0.875rem', sm: '1rem', md: '1.25rem' },
              display: { xs: 'none', sm: 'block' }
            }}
          >
            Admin
          </Typography>
          <Typography
            variant="h6"
            fontWeight="600"
            color="primary.main"
            sx={{
              fontSize: { xs: '0.8rem', sm: '0.9rem' },
              display: { xs: 'block', sm: 'none' },
              maxWidth: '80px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            Admin
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.25, sm: 0.5, md: 1 } }}>
          {/* Theme Toggle */}
          {/* <Tooltip title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
            <IconButton 
              onClick={toggleTheme} 
              color="inherit"
              sx={{
                transition: 'transform 0.3s ease',
                p: { xs: 0.5, sm: 0.75, md: 1 },
                '&:hover': {
                  transform: 'rotate(180deg)',
                },
                '& .MuiSvgIcon-root': { fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem' } }
              }}
            >
              {isDarkMode ? <LightMode /> : <DarkMode />}
            </IconButton>
          </Tooltip> */}

          {/* Notifications */}
          <IconButton
            color="inherit"
            sx={{
              p: { xs: 0.5, sm: 0.75, md: 1 },
              '& .MuiSvgIcon-root': { fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem' } }
            }}
            // onClick={() => navigate('/admin/notifications')}
            onClick={handleClick}
          >
            <Badge
              badgeContent={rootNotificationCount}
              color="error"
              sx={{
                '& .MuiBadge-badge': {
                  fontSize: { xs: '0.6rem', sm: '0.65rem', md: '0.75rem' },
                  minWidth: { xs: '14px', sm: '16px', md: '20px' },
                  height: { xs: '14px', sm: '16px', md: '20px' },
                }
              }}
            >
              <Notifications />
            </Badge>
          </IconButton>

          <Popover
            open={open}
            sx={{
              '& .MuiPaper-root': {
                borderRadius: '12px',
                boxShadow: '0px 4px 20px rgba(0,0,0,0.1)'
              }
            }}
            anchorEl={notificationAnchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            {/* Notifications List */}
            <Typography variant='h5' sx={{ m: 2 }}> Notifications</Typography>
            <Box sx={{ maxHeight: 400, overflow: 'auto' }}>

              {notifications.length > 0 ?
                notifications.map((item) => (
                  <Box
                    key={item.id}
                    onClick={() => {
                      handleNotificationRead(item.id, item.type, item.outlet_id)
                      handleClose();
                    }}
                    sx={{
                      p: 2,
                      width: 320,
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0',
                      bgcolor: item.is_read ? 'white' : '#EBF5FF',
                      transition: 'all 0.2s',
                      '&:hover': {
                        bgcolor: '#E0E7FF'
                      }
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      {/* Colored dot based on type */}
                      <Box sx={{
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        bgcolor: item.type === 'CATERING' ? '#FF6B35' : '#4F46E5'
                      }} />

                      <Typography variant="body1" sx={{ fontWeight: 500 }}>
                       New {item.type} Order is Received
                      </Typography>

                      {!item.is_read && (
                        <Box sx={{
                          ml: 'auto',
                          px: 1,
                          py: 0.3,
                          bgcolor: '#3B82F6',
                          color: 'white',
                          borderRadius: '10px',
                          fontSize: '10px',
                          fontWeight: 600
                        }}>
                          NEW
                        </Box>
                      )}
                    </Box>

                    <Typography variant="body2" sx={{ color: '#6B7280', mt: 0.5, ml: 2.5 }}>
                      {item.outlet_name} • {item.time_ago}
                    </Typography>
                  </Box>
                )) : (
                  <Typography variant='body2' sx={{m:2}}>
                    No New Notifications
                  </Typography>
                )}
            </Box>

            {/* See All Button */}
            <Button
              fullWidth
              onClick={handleSeeAll}
              sx={{
                textTransform: 'none',
                py: 1.5,
                borderTop: '1px solid #E5E7EB',
                color: '#4F46E5',
                fontWeight: 600,
                '&:hover': {
                  bgcolor: '#F3F4F6'
                }
              }}
            >
              See all notifications
            </Button>
          </Popover>

          {/* Home Page Button */}
          <Tooltip title="Go to Public Website (will log you out)">
            <Button
              variant="outlined"
              startIcon={<Home sx={{ fontSize: { xs: '1rem', sm: '1.2rem', md: '1.4rem' } }} />}
              onClick={handleHomePageNavigation}
              sx={{
                borderColor: 'warning.main',
                color: 'warning.main',
                '&:hover': {
                  borderColor: 'warning.dark',
                  bgcolor: 'warning.50',
                },
                mr: { xs: 0.25, sm: 0.5, md: 1 },
                px: { xs: 0.75, sm: 1, md: 2 },
                py: { xs: 0.5, sm: 0.75, md: 1 },
                fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.875rem' },
                minWidth: 'auto',
              }}
            >
              {isMobile ? 'Home' : 'Public Website'}
            </Button>
          </Tooltip>

          {/* User Menu */}
          <IconButton
            onClick={handleMenuOpen}
            sx={{ ml: { xs: 0.25, sm: 0.5, md: 1 }, p: { xs: 0.5, sm: 0.75, md: 1 } }}
          >
            <Avatar
              sx={{
                width: { xs: 28, sm: 32, md: 40 },
                height: { xs: 28, sm: 32, md: 40 },
                bgcolor: 'primary.main',
                fontSize: { xs: '0.7rem', sm: '0.8rem', md: '1rem' },
                fontWeight: 600,
              }}
            >
              {user?.username?.charAt(0).toUpperCase() || 'A'}
            </Avatar>
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            onClick={handleMenuClose}
            PaperProps={{
              elevation: 8,
              sx: {
                mt: 1.5,
                minWidth: 200,
                borderRadius: 0,
                '& .MuiMenuItem-root': {
                  px: 2,
                  py: 1,
                  borderRadius: 0,
                  mx: 1,
                  '&:hover': {
                    bgcolor: 'action.hover',
                  },
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <Box sx={{ px: 2, py: 1 }}>
              <Typography variant="subtitle1" fontWeight="600">
                {user?.full_name || user?.username}
              </Typography>
              {/* <Typography variant="body2" color="text.secondary">
                {user?.email || 'Admin User'}
              </Typography> */}
            </Box>

            <Divider sx={{ my: 1 }} />

            {/* <MenuItem onClick={handleMenuClose}>
              <ListItemIcon>
                <AccountCircle sx={{ fontSize: '1.4rem' }} />
              </ListItemIcon>
              Profile
            </MenuItem> */}

            {/* <MenuItem onClick={handleMenuClose}>
              <ListItemIcon>
                <Settings sx={{ fontSize: '1.4rem' }} />
              </ListItemIcon>
              Settings
            </MenuItem> */}

            {/* <MenuItem onClick={(e) => e.stopPropagation()}>
              <ListItemIcon>
                <Brightness4 sx={{ fontSize: '1.4rem' }} />
              </ListItemIcon>
              <FormControlLabel
                control={
                  <Switch
                    checked={isDarkMode}
                    onChange={toggleTheme}
                    size="small"
                  />
                }
                label={isDarkMode ? 'Dark Mode' : 'Light Mode'}
                sx={{ 
                  m: 0,
                  '& .MuiFormControlLabel-label': {
                    fontSize: '0.875rem',
                  }
                }}
              />
            </MenuItem> */}

            {/* <Divider sx={{ my: 1 }} /> */}

            <MenuItem onClick={handleLogout} sx={{ color: 'error.main' }}>
              <ListItemIcon>
                <Logout sx={{ fontSize: '1.4rem' }} color="error" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
